/**
 * Touch Zoom Plugin for uPlot (X-axis only)
 * Enables pinch-to-zoom on mobile devices
 */

import uPlot from "uplot";

export function touchZoomPlugin() {
  return {
    hooks: {
      init: (u: uPlot) => {
        const over = u.over;
        let rect: DOMRect;
        let oxRange: number, xVal: number;
        const fr = { x: 0, d: 1, dx: 0 };
        const to = { x: 0, d: 1, dx: 0 };

        function storePos(t: typeof fr, e: TouchEvent) {
          const ts = e.touches;
          const t0 = ts[0];
          const t0x = t0.clientX - rect.left;

          if (ts.length === 1) {
            t.x = t0x;
            t.d = t.dx = 1;
          } else {
            const t1 = ts[1];
            const t1x = t1.clientX - rect.left;

            const xMinT = Math.min(t0x, t1x);
            const xMaxT = Math.max(t0x, t1x);

            t.x = (xMinT + xMaxT) / 2;
            t.dx = xMaxT - xMinT;
            t.d = t.dx;
          }
        }

        let rafPending = false;

        function zoom() {
          rafPending = false;
          const left = to.x;
          const xFactor = fr.d / to.d;
          const leftPct = left / rect.width;

          const nxRange = oxRange * xFactor;
          const nxMin = xVal - leftPct * nxRange;
          const nxMax = nxMin + nxRange;

          u.setScale("x", { min: nxMin, max: nxMax });
        }

        function touchmove(e: TouchEvent) {
          storePos(to, e);
          if (!rafPending) {
            rafPending = true;
            requestAnimationFrame(zoom);
          }
        }

        over.addEventListener("touchstart", (e: TouchEvent) => {
          rect = over.getBoundingClientRect();
          storePos(fr, e);
          oxRange = u.scales.x.max! - u.scales.x.min!;
          const left = fr.x;
          xVal = u.posToVal(left, "x");
          document.addEventListener("touchmove", touchmove, { passive: true });
        });

        over.addEventListener("touchend", () => {
          document.removeEventListener("touchmove", touchmove);
        });
      },
    },
  };
}
